import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';

@Injectable()
export class InboxSortService {
sortCondition: any='';
folderCount: any[];
queueCd:any='';

sortConditionChange: Subject<string> = new Subject<string>();
folderCountChange: Subject<string[]>= new Subject<string[]>();
queueCdChange: Subject<string> = new Subject<string>();

  constructor() {
    // this.sortCondition = 
   }

  public setSortCondition(sortCondition: any){
    this.sortCondition = sortCondition;
    this.sortConditionChange.next(this.sortCondition);
  }

  public getSortCondition(){
    return this.setSortCondition;
  }

  public setFolderCount(folderCount: any[]){
    this.folderCount=folderCount
    this.folderCountChange.next(this.folderCount)
  }

  public getFolderCount(){
    // return this.setFolderCount;
    return this.folderCountChange;
  }

   public setQueueCd(queueCd: any){
    this.queueCd = queueCd;
    this.queueCdChange.next(this.queueCd);
  }

  public getQueueCd(){
    // alert("here")
    return this.queueCdChange;
  }

}
